import { useCallback } from "react";
import posthog from 'posthog-js'

const useEventTracking = () => {
  const trackEvent = useCallback((eventName: string, properties={}) => {
    // Send a copy to PostHog
    posthog.capture(eventName, properties)

    // Make sure data layer is available, the push the event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...properties
    });
    // Push another copy of the event to be picked up by a generic GA4 event trigger
    window.dataLayer.push({'event': 'ga4_event', 'ga4_eventName': eventName});
  }, []);

  return trackEvent;
};

export default useEventTracking;